// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"Breadcrumb__2S5BO","Breadcrumb_item":"Breadcrumb_item__2S5BO","Breadcrumb_url":"Breadcrumb_url__2S5BO","Breadcrumb_url___current":"Breadcrumb_url___current__2S5BO"};